<template>
  <div v-title.async="title">
    <img :src="config.background" class="background" alt>
    <div class="banner">
      <div class="binding" v-if="!isBind" @click="bindToast(false)">
        你好，请先
        <span>【绑定账号】</span>
      </div>
      <div class="binding" v-if="isBind" @click="rebind">
        {{ characName ? `你好，${characName}` : "点击" }}
        <span>【切换角色】</span>
      </div>
    </div>

    <div
      class="sign-btn"
      @click="sign"
      :style="{
        backgroundImage: 'url(' + btnImg + ')',
        backgroundSize: '100% 100%',
        top: config.btn_top / 50 + 'rem'
      }"
    ></div>
    <span
      class="txt"
      :style="{
        top: config.signin_day_text_top / 50 + 'rem',
        color: config.signin_day_text_color
      }"
    >{{ config.signin_day_text }}</span>

    <loading :show="loading"></loading>
    <Toast :show.sync="showAwardToast" :award="award" :config="config"></Toast>
  </div>
</template>

<script>

// @ is an alias to /src
import api from '@/api'
import Loading from '@/components/Loading/Loading.vue'
import Toast from '@/components/CustomToast/CustomToast.vue'
import wxMethods from '@/utils/wxMethods'

export default {
  name: 'index',
  data() {
    return {
      title: '',
      loading: false,
      config: {},
      dailyReward: [],
      rewards: [],
      id: this.$route.query.id,
      site: this.$route.query.site,
      isBind: false,
      serverSelect: {},
      btnState: 0,
      gameTool: {},
      game: this.$route.query.game,
      characName: '',
      showAwardToast: false,
      award: {},
      signinDayText: '',
      errMsg: '',
      platform: 1,
    }
  },
  components: {
    Loading,
    Toast,
  },
  computed: {
    btnImg() {
      let url = ''
      switch (this.btnState) {
        case 0:
          url = this.config.signin_btn
          break
        case 1:
          url = this.config.signed_btn
          break
        case 2:
          url = this.config.award_btn
          break
        default:
      }
      return url
    },
  },
  mixins: [wxMethods],
  mounted() {
    this.title = '每日签到'
  },
  created() {
    this.wxHideMenu()
    this.getTem()
  },
  methods: {
    getTem() {
      api
        .getTemplate({
          id: this.id,
        })
        .then((res) => {
          const { result } = res
          if (!result) {
            // this.$router.push({ path: '/404' })
            return
          }
          this.config = result
          this.signinDayText = result.signin_day_text
          this.config.signin_day_text = this.signinDayText.replace(/n/, '0')
          this.dailyReward = result.rewards.filter(reward => reward.reward_type === 1)
          this.platform = result.platform || 1
          const data = result.rewards.filter(reward => reward.reward_type === 2)
          for (let i = 0, len = data.length; i < len; i += result.column_num) {
            this.rewards.push(data.slice(i, i + this.config.column_num))
          }
          this.bindInt()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    bindInt() {
      const that = this
      let platform = ''
      switch (this.platform) {
        case 1:
          platform = 'wx'
          break
        case 2:
          platform = 'qq'
          break
        case 3:
          platform = ['wx', 'qq']
          break
        default:
          platform = 'wx'
      }
      this.gameTool = new GameTools({
        site: this.site,
        game: this.game,
        allowPlatForm: platform,
        loginType: 'wx',
      })

      this.gameTool
        .getRole()
        .then((res) => {
          if (!res.hasRole) {
            this.serverSelect = res.serverSelect
          } else {
            this.characName = res.roleInfo.charac_name
            // 同一游戏，已经绑定了QQ角色，但是该平台只允许微信登陆，让其重新绑定微信
            if (res.roleInfo.acctype === 'qq' && that.platform === 1) {
              that.rebind()
              this.isBind = false
              return
            }
            this.isBind = true
            this.getState()
          }
        })
        .catch((err) => {
          console.log(err)
          this.game = null
          alert('找不到该游戏')
        })
    },

    bindToast(rebind) {
      if (!this.game) {
        alert('找不到该游戏')
        return
      }
      if (this.platform === 2) {
        loginManager.platform('qqconnect').isLogin((islogin) => {
          if (!islogin) {
            loginManager.platform('qqconnect').check()
          }
        })
      }
      const that = this
      const modal = new GameModal({
        gameTool: this.gameTool,
        serverSelect: this.serverSelect,
        confirmText: rebind ? '确认更改' : '确认绑定',
        showClose: true,
        qqConnectLogin: this.platform !== 1,
      })

      modal.show()
      modal.created = function create(el) {
        const caption = document.createElement('h2')
        caption.innerHTML = '请选择区服信息'
        el.querySelector('.game-tools-modal').insertBefore(caption, el.querySelector('.gt-form-item'))
        if (this.platform !== 1 && el.querySelector('#unbind-btn')) {
          el.querySelector('#unbind-btn').style.marginLeft = '15px'
        }
      }
      modal.afterBind = (isBinded, characName) => {
        modal.hide()
        if (isBinded) {
          // if (!rebind) {
          //   that.register()
          // }
          that.isBind = true
          that.characName = characName
          this.getState()
        } else {
          alert('暂时没有角色')
        }
      }
      modal.afterUnBind = (isUnBinded) => {
        if (isUnBinded) {
          modal.hide()
          this.isBind = false
          this.characName = ''
          alert('解绑成功')
        } else {
          alert('解绑失败，请重试')
        }
      }
    },

    rebind() {
      if (!this.game) {
        alert('请检查活动id与游戏是否匹配')
        return
      }
      if (this.loading) {
        return
      }
      this.loading = true
      this.gameTool
        .getServerSelect(this.game)
        .then((serverSelect) => {
          this.loading = false
          this.serverSelect = serverSelect
          this.bindToast(true)
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },

    getState() {
      api
        .getState({
          id: this.id,
        })
        .then((res) => {
          const { result } = res
          if (!result) {
            this.errMsg = res.msg
            return
          }
          if (result.lottery) {
            this.setBtnState(result.today_signin, result.lottery.status)
          } else {
            this.setBtnState(result.today_signin, 0)
          }

          this.config.signin_day_text = this.signinDayText.replace(/n/, result.signin_count)
        })
    },

    // todaySignin  今日是否签到：0未签到，1已签到
    // lotteryStatus  0 未发奖 1发奖成功 2 发奖失败 3本次无奖励
    setBtnState(todaySignin, lotteryStatus) {
      if (todaySignin) {
        this.btnState = lotteryStatus === 2 ? 2 : 1
      } else {
        this.btnState = 0
      }
    },

    sign() {
      if (this.loading) {
        return
      }

      switch (this.btnState) {
        case 0:
          this.isBind ? this.register() : this.bindToast()
          break
        case 1:
          break
        case 2:
          this.retryLottery()
          break
        default:
      }
    },
    register() {
      if (this.loading) {
        return
      }
      this.loading = true
      api
        .register({
          id: this.id,
        })
        .then((res) => {
          // const res = {
          //       "code": 2001,
          //       "msg": "ok",
          //       "result": {
          //             "today_signin": 1,
          //             "signin_count": 2,
          //             "signin_type": 2,
          //             "lottery": {
          //                 "status": 3,
          //                 "hint_no_reward": "继续签到会有大奖哦！",
          //                 "reward": null
          //             },
          //             "reward_info": null
          //       }

          //   }
          this.loading = false
          const { result } = res
          if (!result) {
            alert(res.msg)
            return
          }
          this.setBtnState(result.today_signin, result.lottery.status)
          this.config.signin_day_text = this.signinDayText.replace(/n/, result.signin_count)
          // lotteryStatus  0 未发奖 1发奖成功 2 发奖失败 3本次无奖励
          if (result.lottery.status === 1) {
            this.award = result.reward_info
            this.showAwardToast = true
          }
          // 禁用通用奖励时，有可能发生本次签到无奖励情况。提示msg
          if (result.lottery.status === 3) {
            this.award = {
              reward_msg: result.lottery.hint_no_reward,
            }
            this.config.receive_title = '签到成功'
            this.showAwardToast = true
          }
        })
    },
    retryLottery() {
      if (this.loading) {
        return
      }
      this.loading = true
      api
        .retryLottery({
          id: this.id,
        })
        .then((res) => {
          const { result } = res
          this.loading = false
          this.setBtnState(1, result.status)
          if (result.status === 1) {
            this.award = result.reward_info
            this.showAwardToast = true
          } else {
            alert('发奖失败，请重试')
          }
        })
    },
  },
}
</script>

<style lang="scss" src="./custom.scss" scoped></style>
